import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Avenir Next';
    src: url('./assets/fonts/AvenirNext.ttc') format('ttc');
  }
  @font-face {
    font-family: 'Cormorant Infant';
    src: url('./assets/fonts/CormorantInfant-Regular.otf') format('otf');
  }
  body {
    margin: 0;
    padding: 0;
    background-color: rgb(249,249,249);
    &::-webkit-scrollbar {
    width: 0 !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale; 
  }
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale; 
  }
`;
